import AuthGuest from "../guest/AuthGuest"

const BlogsService = {
    getBlogs: (params: any) => AuthGuest().get(`/api/blogs`, {params}),
    getBlogCategories: (params: any) => AuthGuest().get(`/api/blogs/categories`, {params}),
    getSingleBlog: (slug: string) => AuthGuest().get(`/api/blog/${slug}`),
    getBlogCities: (params: any) => AuthGuest().get(`/api/blogs/cities`, {params})
}

export default BlogsService
